import React, { useEffect } from "react"
import { Row, Col, Card, CardBody } from "reactstrap"
import { useTranslation } from "react-i18next"
//redux
import { useDispatch, useSelector } from "react-redux"
import { initLoadMessage } from "../../store/actions"
import dictionary from "../../config/dictionary"
import LabelChargeData from "../../components/Common/labelChargeData"
const Messages = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { typesMessages, typesLoadding, currentUser } = useSelector(state => {
    return {
      typesMessages: state.MessageDashBoard.types,
      typesLoadding: state.MessageDashBoard.loading,
      currentUser: state.Dashboard.user,
    }
  })
  useEffect(() => {
    dispatch(initLoadMessage(dictionary.configApp.type.typeMessage))
  }, [])

  const listItems = typesMessages.map(item => {
    return item.status === 1 ? (
      <li key={item.id} className="event-list active">
        <div className="event-timeline-dot">
          <i className="bx bxs-right-arrow-circle font-size-18  " />
        </div>

        <Row>
          <Col>
            <h5 className="font-size-14 text-primary">{item.name} </h5>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="flex-grow-1">
              <div>{item.text}</div>
            </div>
          </Col>
        </Row>
      </li>
    ) : null
  })
  return (
    <React.Fragment>
      {currentUser?.supplier ? (
        <Card>
          <CardBody>
            <Row>
              <Col>
                <LabelChargeData
                  label={""}
                  showloading={typesLoadding}
                  title={t("global:loading")}
                />
              </Col>
            </Row>
            <ul className="verti-timeline list-unstyled">{listItems}</ul>
            <div className="text-center mt-4"></div>
          </CardBody>
        </Card>
      ) : null}{" "}
    </React.Fragment>
  )
}
export default Messages
